module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/AR-cc814a0868e1d78ced9a873907650b96.png";